import { GET_RTB_HOUSE_AD_ACCOUNTS } from './actions/getAdAccounts.action';

import { ReduxAsyncActionsService } from '../../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import { INIT_STATE } from './RTBHouse.constants';
import type { RTBHouseState } from './RTBHouse.types';

function handler(state: WrappedReducer<RTBHouseState>, action: any): WrappedReducer<RTBHouseState> {
  switch (action.type) {
    case GET_RTB_HOUSE_AD_ACCOUNTS.response: {
      const { accounts } = action.data;
      return {
        ...state,
        adAccounts: accounts,
        loading: false,
      };
    }

    default:
      return state;
  }
}

const RTBHouse = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_RTB_HOUSE_AD_ACCOUNTS],
  error: [GET_RTB_HOUSE_AD_ACCOUNTS],
  resetOn: ['APP_CHANGE'],
});

export default RTBHouse;
